import React, { useRef } from 'react';

export const MediaPlayer = (props) => {
  const audioPlayerRef = useRef();
  const { mediaUrl } = props;

  const playAudio = (e) => {
    audioPlayerRef.current.play();
  };

  return (
    <>
      <button className="audio-btn" onClick={playAudio} aria-label="Play audio" type="button">▶</button>
      <audio ref={audioPlayerRef}>
        <source src={mediaUrl} type="audio/mpeg" />
      </audio>
    </>
  );
};
